module.exports = __webpack_public_path__ + "img/ic_done.05f50dd1.svg";